import { render } from "./AdBannerApplicationsView.vue?vue&type=template&id=a2587d00"
import script from "./AdBannerApplicationsView.vue?vue&type=script&lang=js"
export * from "./AdBannerApplicationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__